import api from 'api';

export const PDF_DOWNLOAD_START = 'PDF_DOWNLOAD_START';
export const PDF_DOWNLOAD_ERROR = 'PDF_DOWNLOAD_ERROR';
export const PDF_DOWNLOAD_RECIPE_CARD_SUCCESS = 'PDF_DOWNLOAD_RECIPE_CARD_SUCCESS';
export const PDF_EXTERNAL_ASYNC_SUCCESS = 'PDF_EXTERNAL_ASYNC_SUCCESS';
export const EXCEL_DOWNLOAD_START = 'EXCEL_DOWNLOAD_START';
export const EXCEL_DOWNLOAD_ERROR = 'EXCEL_DOWNLOAD_ERROR';
export const EXCEL_DOWNLOAD_MENU_SUCCESS = 'EXCEL_DOWNLOAD_MENU_SUCCESS';
export const WORD_DOWNLOAD_START = 'WORD_DOWNLOAD_START';
export const WORD_DOWNLOAD_ERROR = 'WORD_DOWNLOAD_ERROR';
export const WORD_DOWNLOAD_MENU_SUCCESS = 'WORD_DOWNLOAD_MENU_SUCCESS';
export const LABOR_COST_CALCULATOR_DOWNLOAD_SUCCESS = 'LABOR_COST_CALCULATOR_DOWNLOAD_SUCCESS';

function pdfDownloadStart() {
  return {
    type: PDF_DOWNLOAD_START,
  };
}

function pdfDownloadError() {
  return {
    type: PDF_DOWNLOAD_ERROR,
  };
}

function excelDownloadStart() {
  return {
    type: EXCEL_DOWNLOAD_START,
  };
}

function excelDownloadError() {
  return {
    type: EXCEL_DOWNLOAD_ERROR,
  };
}

function wordDownloadStart() {
  return {
    type: WORD_DOWNLOAD_START,
  };
}

function wordDownloadError() {
  return {
    type: WORD_DOWNLOAD_ERROR,
  };
}

function pdfDownloadRecipeSuccess(data, recipeName) {
  return {
    type: PDF_DOWNLOAD_RECIPE_CARD_SUCCESS,
    data,
    recipeName,
  };
}

function excelDownloadMenuSuccess(data, menuName) {
  return {
    type: EXCEL_DOWNLOAD_MENU_SUCCESS,
    data,
    menuName,
  };
}

function wordDownloadMenuSuccess(data, menuName) {
  return {
    type: WORD_DOWNLOAD_MENU_SUCCESS,
    payload: { data, menuName }
  };
}

const laborCostCalculatorDownloadSuccess = data => {
  return {
    type: LABOR_COST_CALCULATOR_DOWNLOAD_SUCCESS,
    data,
  };
};

function externalPdfSuccess(data, fileName) {
  return {
    type: PDF_EXTERNAL_ASYNC_SUCCESS,
    data,
    fileName,
  };
}

export function getRecipeCardAsync(recipeId, recipeName) {
  return (dispatch, getState) => {
    dispatch(pdfDownloadStart());
    return api.request(`report/recipeCard/${ recipeId }?showDetail=N`, 'get', null, null, api.responseTypes.stream)
    .then((data) => {
      dispatch(pdfDownloadRecipeSuccess(data, recipeName));
      return data;
    })
    .catch((err) => {
      dispatch(pdfDownloadError());
      throw (err);
    });
  };
}

export function getRecipeCostsCardAsync(recipeId, recipeName) {
  return (dispatch, getState) => {
    dispatch(pdfDownloadStart());
    return api.request(`report/recipeCard/${ recipeId }?showDetail=Y`, 'get', null, null, api.responseTypes.stream)
    .then((data) => {
      dispatch(pdfDownloadRecipeSuccess(data, recipeName));
      return data;
    })
    .catch((err) => {
      dispatch(pdfDownloadError());
      throw (err);
    });
  };
}

export function getDownloadMenuExcelFileAsync(menuId, periodId, menuName) {
  return (dispatch, getState) => {
    dispatch(excelDownloadStart());

    const periodIdForDownload = periodId === null ? 0 : periodId;
    return api.request(`menuItemSale/export/${ menuId }?periodId=${ periodIdForDownload }`, 'get', null, null, api.responseTypes.stream)
    .then((data) => {
      dispatch(excelDownloadMenuSuccess(data, menuName));
      return data;
    })
    .catch((err) => {
      dispatch(excelDownloadError());
      throw (err);
    });
  };
}

/**
 * Call API to download Labor Cost Calculator.xlsx
 */
export const downloadLaborCostCalculatorAsync = () => {
  return (dispatch, getState) => {
    dispatch(excelDownloadStart());

    return api.request('menuItemSale/labor/cost-calculator', 'get', null, null, api.responseTypes.stream)
    .then((data) => {
      dispatch(laborCostCalculatorDownloadSuccess(data));
      return data;
    })
    .catch((err) => {
      console.log("Error:downloadLaborCostCalculatorAsync: ", err);
      dispatch(excelDownloadError());
      throw (err);
    });
  };
};

export function getExternalPdfAsync(url, fileName) {
  return (dispatch) => {
    dispatch(pdfDownloadStart());
    return api.requestExternalNoCache(url, 'get')
    .then((data) => {
      dispatch(externalPdfSuccess(data, fileName));
      return data;
    })
    .catch((err) => {
      dispatch(pdfDownloadError());
      throw (err);
    });
  };
}

export function getBulkDownloadRecipeCardAysnc(isSingleRecipe, showDetail, recipeIds, recipeName) {
  return (dispatch, getState) => {
    dispatch(pdfDownloadStart());
    let apiRequestPath = '';
    if(isSingleRecipe) {
      apiRequestPath = `report/recipeCard/${ recipeIds }?showDetail=${ showDetail }`;
    } else {
      apiRequestPath = `report/recipeCard?recipeIds=${ recipeIds }&showDetail=${ showDetail }`;
    }
    return api.request(apiRequestPath, 'get', null, null, api.responseTypes.stream)
    .then((data) => {
      dispatch(pdfDownloadRecipeSuccess(data, recipeName));
      return data;
    })
    .catch((err) => {
      dispatch(pdfDownloadError());
      throw (err);
    });
  };
}

export function getDownloadMenuWordFileAsync(menuId, menuName) {
  return (dispatch, getState) => {
    dispatch(wordDownloadStart());

    return api.request(`menuItem/export/word/${ menuId }`, 'get', null, null, api.responseTypes.stream)
    .then((data) => {
      dispatch(wordDownloadMenuSuccess(data, menuName));
      return data;
    })
    .catch((err) => {
      dispatch(wordDownloadError());
      throw (err);
    });
  };
}